export default {
  CREATE_OUTLAYCATEGORIES (state, item) {
    state.outlaycategories.unshift(item)
  },

  SET_OUTLAYCATEGORIES (state, outlaycategories) {
    state.outlaycategories = outlaycategories
  },

  UPDATE_OUTLAYCATEGORIES (state, outlaycategory) {
    const outlaycategoryIndex = state.outlaycategories.findIndex((p) => p.id === outlaycategory.id)
    Object.assign(state.outlaycategories[outlaycategoryIndex], outlaycategory)
  }
}
